import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Header from '../common/Header';

const RegisterPage = () => {
  const { register, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', phone: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null); setSuccess(null);
    if (!form.email || !form.password || !form.first_name || !form.last_name) {
      setError('Please fill the required fields: first name, last name, email, and password.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      setError('Please enter a valid email address.');
      return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters long.');
      return;
    }
    setLoading(true);
    try {
      await register(form);
      // Attempt auto-login to take the user directly to their intended page
      try {
        await login(form.email, form.password);
        const fromView = location.state?.fromView || 'dashboard';
        try { localStorage.setItem('triageos_post_login_view', fromView); } catch (e) {}
        navigate('/', { replace: true });
        setSuccess('Registration successful. Redirecting…');
      } catch (e) {
        // If auto-login fails (rare), fall back to login page while preserving intent
        setSuccess('Registration successful. You can now sign in.');
        setTimeout(() => navigate('/login', { state: { fromView: location.state?.fromView } }), 1200);
      }
    } catch (err) {
      setError(err?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const heroBgUrl = `${process.env.PUBLIC_URL}/images/circular_economy_home.png`;

  return (
    <div className="min-h-screen bg-gray-100">
      <Header currentView="register" />
      <div className="min-h-[90vh] flex items-center justify-center px-4">

           <div className=" flex flex-col lg:flex-row items-center justify-center p-6 border border-cyan-500 bg-cyan-500 rounded-xl shadow">

       <div className="w-full max-w-md bg-cyan-500 p-6 border-cyan- rounded-xl">
         <img src={heroBgUrl} alt="Circular Economy Home" className="max-w-full max-h-full object-cover" />
        </div>

      <div className="w-full max-w-md bg-white p-6 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-1 text-gray-800">Create your account</h2>
        <p className="text-sm text-gray-600 mb-4">Start using TriageOS today.</p>
        {error && <div className="mb-3 p-2 text-sm rounded bg-red-50 text-red-700 border border-red-200">{error}</div>}
        {success && <div className="mb-3 p-2 text-sm rounded bg-green-50 text-green-700 border border-green-200">{success}</div>}
        <form onSubmit={onSubmit} className="space-y-3">
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-sm text-gray-700 mb-1">First name</label>
              <input name="first_name" value={form.first_name} onChange={handleChange} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" />
            </div>
            <div>
              <label className="block text-sm text-gray-700 mb-1">Last name</label>
              <input name="last_name" value={form.last_name} onChange={handleChange} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" />
            </div>
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Email</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="you@example.com" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Phone (optional)</label>
            <input type="tel" name="phone" value={form.phone} onChange={handleChange} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="+1 555 555 5555" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Password</label>
            <input type="password" name="password" value={form.password} onChange={handleChange} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="At least 8 characters" />
          </div>
          <button type="submit" disabled={loading} className={`w-full py-2 rounded text-white font-medium ${loading ? 'bg-gray-400' : 'bg-cyan-600 hover:bg-cyan-700'}`}>{loading ? 'Creating…' : 'Create account'}</button>
        </form>
        <div className="mt-4 text-sm text-center">
          Already have an account? <Link to="/login" className="text-cyan-700 hover:underline">Sign in</Link>
        </div>
      </div>
</div>

</div>
</div>
);
};

export default RegisterPage;
